import { Delete, EditOutlined } from '@mui/icons-material';
import { TableCell, TableRow } from '@mui/material';
import React, { memo } from 'react';
import styled from 'styled-components';

const QuoteComponentTable = ({ row, sequence, handlerEdit, handleDelete, index, hasEditQuotes, hasDeleteQuotes }) => {
  return (
    <TableRow
      key={row.id || `row-${index}`}
      style={{
        '&:lastChild td, &:lastChild th': { border: 0 },
      }}
    >
      <StyledTableCell>{sequence + 1}.</StyledTableCell>
      <StyledTableCell>{row?.message}</StyledTableCell>
      <StyledTableCell>{row?.author}</StyledTableCell>
      <StyledTableCell>
        <EditOutlined 
          onClick={() => handlerEdit(index)} 
          style={{ cursor: 'pointer' }}
        />
      </StyledTableCell>
      <StyledTableCell>
        <StyledDeleteButton 
          onClick={() => handleDelete(index)} 
          style={{ cursor: 'pointer' }}
        />
      </StyledTableCell>
    </TableRow>
  );
};

export default memo(QuoteComponentTable);

const StyledDeleteButton = styled(Delete)`
  color: red !important;
`;

const StyledTableCell = styled(TableCell)`
  text-align: left;
  cursor: pointer;
`;